import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/**
 *
 *
 * Amarino TODO: organize this code, if time (or post launch)
 *
 */

function animateHeaderIn() {
    const nav = document.querySelector('[data-target="nav"]')
    const additionalLinks = document.querySelector(
        '[data-target="additional-links"]'
    )
    const leftLinks = document.querySelector('[data-target="left-links"]')
    const leftLinksEls = leftLinks.querySelectorAll('.menu-item-has-children')
    const rightLinks = document.querySelector('[data-target="right-links"]')
    const rightLinksEls = rightLinks.querySelectorAll('.menu-item-has-children')
    const contactRight = document.querySelector('[data-target="contact-right"]')
    const logo = document.querySelector('[data-target="logo"]')

    const logoSvg = document.getElementById('logo-svg')
    const path = logoSvg.querySelector('.symbol')
    const logoText = logo.querySelector('.menu-word')
    const word = logoText.querySelectorAll('span')

    const items = document.querySelectorAll(
        '.menu-item-has-children:not(.sub-menu > .menu-item-has-children)'
    )
    const submenus = document.querySelectorAll('.sub-menu-wrap:not(.level-2)')

    const homeIntro = document.querySelector('[data-target="homepage-intro"]')

    const svgPaths = document.querySelectorAll(
        '[data-target="contact-right"] .svg-contact svg path'
    )

    const circle = additionalLinks.querySelector('svg circle')
    const circlePaths = additionalLinks.querySelectorAll('svg path')

    let enableScroll = false
    let lastScrollY
    let scheduledAnimationFrame = false
    let banner = document.body.classList.contains('page-template-home')
        ? homeIntro
        : document.querySelector('[data-name="banner"]')

    if (window.innerWidth > 1050) {
        document.body.classList.add('overflow-x-clip')
        items.forEach((item, i) => {
            item.firstChild.removeAttribute('href')
            item.firstChild.classList.add('cursor-pointer')
            item.firstChild.dataset.index = i
            let clicked

            item.addEventListener('click', (e) => {
                items.forEach((itemNewLoop, i) => {
                    if (itemNewLoop !== item) {
                        itemNewLoop.firstChild.classList.remove('active')
                    }
                })

                item.firstChild.classList.add('active')

                gsap.to(submenus, {
                    autoAlpha: 0,
                    y: '50px',
                    duration: 0.5,
                })

                gsap.to(item.querySelector('.sub-menu-wrap'), {
                    autoAlpha: 1,
                    y: '0',
                    duration: 0.5,
                })
            })
        })

        document.addEventListener('click', (e) => {
            if (
                !e.target.parentNode.classList.contains(
                    'menu-item-has-children'
                )
            ) {
                items.forEach((item, i) => {
                    item.firstChild.classList.remove('active')
                })
                gsap.to(submenus, {
                    autoAlpha: 0,
                    y: '50px',
                    duration: 0.5,
                })
            }
        })

        const logoTl = gsap.timeline({
            paused: true,
            ease: 'power2.inOut',
            onComplete: () => {
                removeEventListenerClick()
            },
        })

        const showAnim = gsap.timeline({
            paused: true,
            ease: 'power2.inOut',
            onComplete: () => {
                removeEventListenerClick()
            },
        })

        let delay = 0
        let delayWord = 0

        gsap.set(leftLinksEls[0], {
            x: `${leftLinksEls[2].offsetLeft + leftLinksEls[2].offsetWidth}px`,
        })

        gsap.set(leftLinksEls[1], {
            x: `${leftLinksEls[2].offsetLeft + leftLinksEls[2].offsetWidth}px`,
        })

        gsap.set(rightLinksEls[1], {
            x: `-${
                rightLinksEls[2].offsetLeft + rightLinksEls[2].offsetWidth
            }px`,
        })

        gsap.set(rightLinksEls[2], {
            x: `-${
                rightLinksEls[2].offsetLeft + rightLinksEls[2].offsetWidth
            }px`,
        })

        gsap.set(additionalLinks, {
            x: `${logo.offsetLeft - additionalLinks.offsetWidth}px`,
        })

        gsap.set(contactRight, {
            x: `-${logo.offsetLeft - contactRight.offsetWidth}px`,
        })

        if (document.body.classList.contains('page-template-home')) {
            delay = 3500
            delayWord = 2
        } else {
            delay = 0
            delayWord = 1
        }

        gsap.to(logo.querySelector('div'), {
            autoAlpha: 1,
            delay: delay / 2500,
            duration: 0.5,
        })

        gsap.to(word, {
            autoAlpha: 1,
            delay: delayWord,
            pointerEvents: 'none',
        })

        logoTl
            .to(logo, {
                autoAlpha: 1,
                duration: 0.6,
            })
            .to(
                logoText,
                {
                    autoAlpha: 0,
                    duration: 0.5,
                },
                '<'
            )
            .to(
                path,
                {
                    autoAlpha: 1,
                    duration: 0.5,
                },
                '<'
            )
            .to(
                logo,
                {
                    scale: 1,
                    duration: 0.5,
                },
                '<'
            )
            .progress(0)

        showAnim
            .to(additionalLinks, {
                autoAlpha: 1,
                x: '0',
                duration: 0.5,
            })
            .to(
                contactRight,
                {
                    autoAlpha: 1,
                    x: '0',
                    duration: 0.5,
                },
                '<'
            )
            .to(
                leftLinks,
                {
                    autoAlpha: 1,
                    x: '0',
                    duration: 0.75,
                },
                '<0.05'
            )
            .to(
                rightLinks,
                {
                    autoAlpha: 1,
                    x: '0',
                    duration: 0.75,
                },
                '<'
            )
            .to(
                leftLinksEls,
                {
                    x: '0',
                    duration: 0.35,
                    stagger: 0.005,
                },
                '<'
            )
            .to(
                rightLinksEls,
                {
                    autoAlpha: 1,
                    x: '0',
                    duration: 0.35,
                    stagger: 0.005,
                },
                '<'
            )

        showAnim.timeScale(0.25)
        logoTl.timeScale(0.25)

        // for when the page loads
        if (window.scrollY < window.innerHeight * 0.5) {
            logoTl.play()

            setTimeout(() => {
                showAnim.play()
            }, delay)

            removeEventListenerClick()
            removeEventListenerScroll()
        } else {
            logoTl.reverse()
            showAnim.reverse()

            addEventListenerClick()

            addEventListenerScroll()
        }

        function onScroll() {
            lastScrollY = window.scrollY
            if (scheduledAnimationFrame) return

            scheduledAnimationFrame = true
            requestAnimationFrame(readAndUpdatePage)
        }

        function readAndUpdatePage() {
            if (window.scrollY > banner.offsetHeight * 0.5) {
                addEventListenerClick()
                addEventListenerScroll()

                logoTl.timeScale(0.7)
                logoTl.reverse()
                showAnim.timeScale(0.7)
                showAnim.reverse()

                if (
                    window.scrollY >
                    document.body.offsetHeight - window.innerHeight - 25
                ) {
                    removeEventListenerClick()
                    removeEventListenerScroll()

                    logoTl.play()
                    showAnim.play()
                }
            } else {
                removeEventListenerClick()
                removeEventListenerScroll()

                logoTl.play()
                showAnim.play()
            }

            animateSvg()

            scheduledAnimationFrame = false
        }

        function animateSvg() {
            items.forEach((item, i) => {
                if (
                    item.parentNode.parentElement.parentElement.classList.contains(
                        'has-menu-white'
                    )
                ) {
                    if (window.scrollY > window.innerHeight * 0.5) {
                        gsap.to(item.querySelector('a:first-child'), {
                            color: 'rgb(19 36 83 / 1)',
                        })

                        document
                            .querySelector('.current-page-ancestor > a')
                            .classList.remove('after:!bg-white')

                        document
                            .querySelector('.current-page-ancestor > a')
                            .classList.add('after:!bg-blue')

                        document
                            .querySelector('[data-target="contact-right"] > a')
                            .classList.add('button--blue')

                        document
                            .querySelector(
                                '[data-target="left-links"] a, [data-target="left-right"] a'
                            )
                            .classList.add('after:!bg-blue')

                        document
                            .querySelector('[data-target="contact-right"] > a')
                            .classList.remove('button--white')

                        gsap.to(circle, {
                            fill: 'rgb(19 36 83 / 1)',
                        })

                        circlePaths.forEach((path) => {
                            gsap.to(path, {
                                stroke: 'rgb(255 255 255 / 1)',
                            })
                        })

                        svgPaths.forEach((path) => {
                            path.style.stroke = 'rgb(255 255 255 / 1)'
                        })
                    } else {
                        gsap.to(item.querySelector('a:first-child'), {
                            color: 'white',
                        })
                        document
                            .querySelector('.current-page-ancestor > a')
                            .classList.add('after:!bg-white')
                        document
                            .querySelector('.current-page-ancestor > a')
                            .classList.remove('after:!bg-blue')
                        document
                            .querySelector('[data-target="contact-right"] > a')
                            .classList.add('button--white')

                        document
                            .querySelector(
                                '[data-target="left-links"] a, [data-target="left-right"] a'
                            )
                            .classList.remove('after:!bg-blue')

                        document
                            .querySelector('[data-target="contact-right"] > a')
                            .classList.remove('button--blue')

                        gsap.to(circle, {
                            fill: 'rgb(255 255 255 / 1)',
                        })

                        circlePaths.forEach((path) => {
                            gsap.to(path, {
                                stroke: 'rgb(19 36 83 / 1)',
                            })
                        })

                        svgPaths.forEach((path) => {
                            path.style.stroke = 'rgb(19 36 83 / 1)'
                        })
                    }
                }
            })
        }

        function stopClick(e) {
            e.preventDefault()
            e.stopPropagation()
        }

        function scrollAnimate(e) {
            if (enableScroll === true) {
                logoTl.timeScale(0.7)
                logoTl.reverse()
                showAnim.timeScale(0.7)
                showAnim.reverse()

                nav.classList.remove('bg-white/100')
                nav.classList.add('bg-white/0')
                nav.classList.remove('shadow-black/10')
                nav.classList.add('shadow-black/0')

                logo.addEventListener('click', stopClick)

                enableScroll = false
            }
        }

        function addEventListenerClick() {
            logo.addEventListener('click', stopClick)

            logoText.addEventListener('click', () => {
                enableScroll = true

                nav.classList.add('is-white-bg')
                nav.classList.add('bg-white')
                nav.classList.remove('bg-white/0')
                nav.classList.add('shadow-black/10')
                nav.classList.remove('shadow-black/0')

                showAnim.timeScale(0.7)
                showAnim.play()
                logoTl.timeScale(0.7)
                logoTl.play()
            })
        }

        function addEventListenerScroll() {
            window.addEventListener('scroll', scrollAnimate)
        }

        function removeEventListenerClick() {
            logo.removeEventListener('click', stopClick)
        }

        function removeEventListenerScroll() {
            window.removeEventListener('scroll', scrollAnimate)
        }

        window.addEventListener('scroll', onScroll)
    } else {
        document.body.classList.remove('overflow-x-clip')
        const navMobile = document.querySelector('[data-target="nav-mobile"]')
        const hamburger = document.querySelector('[data-target="hamburger"]')
        const menuEls = navMobile.querySelectorAll('.menu-item-has-children')
        const allSubMenus = navMobile.querySelectorAll('.sub-menu-wrap')
        const quickLinks = document.querySelector('.menu-quick-links-container')
        const quickLinksMobile = document.querySelector(
            '[data-target="quick-links-mobile"]'
        )

        hamburger.addEventListener('click', () => {
            navMobile.classList.toggle('is-active')
            document.body.classList.toggle('overflow-hidden')
        })

        quickLinksMobile.appendChild(quickLinks)

        menuEls.forEach((item, i) => {
            const subMenu = item.querySelector('.sub-menu-wrap:not(.level-2)')

            // item.firstChild.removeAttribute('href')
            item.firstChild.classList.add('cursor-pointer')

            if (subMenu) {
                navMobile.appendChild(subMenu)
            }

            if (item.classList.contains('current-page-ancestor')) {
                const activeSubMenu = item.querySelector('.sub-menu-wrap')
                const back = allSubMenus[i].querySelector('.back-menu')

                gsap.set(allSubMenus[i], {
                    autoAlpha: 1,
                    x: '0',
                })

                back.addEventListener('click', () => {
                    gsap.to(allSubMenus[i], {
                        autoAlpha: 0,
                        x: '100vw',
                        duration: 0.5,
                    })
                })
            }

            item.addEventListener('click', (e) => {
                const back = allSubMenus[i].querySelector('.back-menu')
                gsap.to(allSubMenus[i], {
                    autoAlpha: 1,
                    x: '0',
                    duration: 0.5,
                })

                back.addEventListener('click', () => {
                    gsap.to(allSubMenus[i], {
                        autoAlpha: 0,
                        x: '100vw',
                        duration: 0.5,
                    })
                })
            })
        })
    }
}

function animateHeaderOut() {}

export { animateHeaderIn, animateHeaderOut }
